import { render, staticRenderFns } from "./edit-model-vehicle.vue?vue&type=template&id=fbfa35f2&"
import script from "./edit-model-vehicle.vue?vue&type=script&lang=js&"
export * from "./edit-model-vehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports